'use client';

import { c as _c } from "react/compiler-runtime";
import useTranslations from '@/locales';
import { Button } from '@heroui/button';
import { Link } from '@heroui/link';
import EmptyIcon from '@particle-network/icons/web/EmptyIcon';
import { UXDivider } from '@particle-network/ui-react';
export default function NotFound() {
  const $ = _c(10);
  const locales = useTranslations(_temp);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <EmptyIcon size={48} />;
    t1 = <div className="text-2xl text-white">404</div>;
    t2 = <UXDivider className="w-64" orientation="horizontal" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== locales.notFound.sorry) {
    t3 = <div className="text-foreground-300 text-sm">{locales.notFound.sorry}</div>;
    $[3] = locales.notFound.sorry;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== locales.notFound.gotohome) {
    t4 = <Button variant="bordered" radius="lg" as={Link} className="text-foreground-300" href="/">{locales.notFound.gotohome}</Button>;
    $[5] = locales.notFound.gotohome;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex h-[calc(100vh-var(--header-height)-4rem)] w-full flex-col items-center justify-center gap-5">{t0}{t1}{t2}{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(state) {
  return state.values;
}